import { render, staticRenderFns } from "./ot-textarea.vue?vue&type=template&id=8458d346&scoped=true&"
import script from "./ot-textarea.vue?vue&type=script&lang=ts&"
export * from "./ot-textarea.vue?vue&type=script&lang=ts&"
import style0 from "./ot-textarea.vue?vue&type=style&index=0&id=8458d346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8458d346",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
